import * as React from 'react';
import styled from 'styled-components';
import { TextField } from './TextField';
import * as classNames from 'classnames';
import { intlShape } from 'react-intl';
import { media } from './style-utils';

export interface Props {
  error: boolean;
  phone: string;
  authToken: string;
  id: string;
}

export interface State {
  phone: string;
  active: boolean;
}

export const Form = styled.form`
  margin: 32px auto;
  padding: 32px
  width: 656px;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.3);
  ${media['tablet'] `
    width: calc(100% - 24px);
    padding: 32px 12px;
  `}
  ${media['phone'] `
    margin: 0px auto;
    background-color: transparent;
    box-shadow: initial;
    padding: 12px;
  `}
`;

export const ErrorText = styled.p`
  font-size: 13px;
  color: #ee0000;
  text-align: center;
  margin-top: 25px;
  ${media['phone'] `
    margin-top: 20px;
  `}
`;

export const FormLabel = styled.p`
  margin: 0px 0px 16px 0px;
  font-size: 14px;
  line-height: 1.54;
  color: #333333;
`;

export const Button = styled.button`
  cursor: pointer;
  display: inherit;
  margin: 24px auto 0px auto;
  width: 296px;
  ${media['phone']`
    width: 100%;
  `}
  height: 48px;
  color: #fff;
  border: 0px;
  border-radius: 3px;
  background-color: #bbbbbb;
  box-shadow: 1px 1px 1px 0 rgba(0, 0, 0, 0.2);
  &.active {
    background-color: #77d000;
  }
  ${media['phone'] `
    margin-top: 20px;
  `}
`;

class PhoneForm extends React.Component<Props, State> {
  btnDisabled: boolean = true;
  static get contextTypes() {
    return { intl: intlShape };
  }
  constructor(props: Props) {
    super(props);
    this.state = {phone: props.phone, active: false};
    this.btnDisabled = (props.error || !props.phone);
    this.inputMethod = this.inputMethod.bind(this);
  }
  inputMethod(phone: string) {
    this.setState({phone: phone, active: true});
    if (phone) {
      this.btnDisabled = false;
    }
  };
  render() {
    const { formatMessage } = this.context.intl;
    const btnClass = classNames({
      active: !!this.state.phone && this.state.active
    });
    const { phone, error, authToken, id } = this.props;
    return (
      <Form action="/-/content" method="post" acceptCharset="UTF-8">
        <FormLabel>
          {formatMessage({id: 'phoneNumberText'})}
        </FormLabel>
        <input type="hidden" name="authenticity_token" value={authToken} />
        <input type="hidden" name="id" value={id} />
        <TextField name="phone_no" defaultValue={phone} inputMethod={this.inputMethod}
                   label={formatMessage({id: 'phoneNumber'})} type="tel"/>
        <ErrorText hidden={this.state.active || !error}>{formatMessage({id: 'phoneNumberError'})}</ErrorText>
        <Button className={btnClass}>{(this.btnDisabled) ? formatMessage({id: 'phoneNumberDisabledButton'})
                                                        : formatMessage({id: 'phoneNumberEnabledButton'})}</Button>
      </Form>
    );
  }
}

export default PhoneForm;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/PhoneForm.tsx